import { useEffect, useState } from 'react'; // , useContext
// import { Link } from 'react-router-dom';
import DisplayRegistrations from '../../components/DisplayRegistrations';
import axiosInstance from "../../helpers/Axios";
import type {IContact} from '../../interfaces/IContact';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material';

const defaultList: ICourseObj[] = [];

interface IDay {
  name: string;
}

interface ICourse {
  shortName: string;
  name: string;
  day: IDay;
  isVisible: boolean;
  startTime: string;
  endTime: string;
}

interface ICourseObj {
  course: ICourse;
  subscribes: IContact[];
}


const Courses = () => {

  const [list, setList] = useState(defaultList);
  const [visible, setVisible] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [resetting, setResetting] = useState(false);
  const loading = list === defaultList && visible;

useEffect(() => {
  if(loading)
    axiosInstance.get("/course?withStudents=true")
      .then(response => {
        //console.log('response', response);

        setList(response.data);//.map((courseObj : ICourseObj) => courseObj.course))
        // console.log("réponse",response.data);
        // setUserProfile(response.data);
        // setLocation(response.data.location);
      })
      .catch((err) => {
        const error = err.response === undefined ?
          'Server in not reachable'
          : err.response.data;
        console.log('error', error);
        setVisible(false);
      });
    }
 );

const resetYear = () => {
  setResetting(true);
  axiosInstance.post("/student/reset-year")
    .then(() => {
      setList(defaultList); // force un rechargement de la liste (et des couleurs) à jour
    })
    .catch((err) => console.log('error resetting year', err))
    .finally(() => {
      setResetting(false);
      setConfirmOpen(false);
    });
};

//  console.log("list",list);

  return (
    <div id="courses">
      <div id="title">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 2 }}>
          <h1>Inscriptions par cours</h1>
          <Button variant="outlined" color="warning" onClick={() => setConfirmOpen(true)}>
            Réinitialiser l'année
          </Button>
        </Box>
      </div>
      <div id="content">
        {
        loading ?
        <p>Chargement en cours...</p>
        :
        visible ?
          <DisplayRegistrations stages={undefined} courses={list} title="Choisir votre cours"/>
          :
            <div>
              <p>Le système d'inscription est actuellement en panne.</p>
            </div>
            }
      </div>

      <Dialog open={confirmOpen} onClose={() => setConfirmOpen(false)}>
        <DialogTitle>Réinitialiser les données de l'année ?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Cette action remet à zéro le droit à l'image, l'assurance, le paiement et le solde restant
            pour TOUS les élèves, dans TOUS les cours. À faire une seule fois, en début d'année scolaire.
            Confirmer ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setConfirmOpen(false)} disabled={resetting}>Annuler</Button>
          <Button onClick={resetYear} color="warning" disabled={resetting}>
            {resetting ? 'En cours...' : 'Confirmer'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  )
};

export default Courses;
